import * as React from 'react'
import { SelectCl } from "../../../components/select-cl"
import { InputTextCl } from "../../../components/input-text-cl"
import { useEffect, useCallback, useRef, useState } from "react"
import { fetchCountries, fetchIsmagIssuers } from "./service"
import { useDispatch, useSelector } from 'react-redux'
import { domainIsmagType } from "./domains"
import { RootReducer } from '../../../components/app/reducer'
import Disclaimer from "../../../components/disclaimer"
import { useHistory } from "react-router"

const IsmagCriteria: React.FC = () => {
    const rootDispatch = useDispatch();
    const rootDispatchHistory = useDispatch();
    const criteriaOrSearchError = useSelector((state: RootReducer) => { return state.ismagCriteriaReducer.error || state.ismagReducer.error });    
    const disclaimerAccepted = useSelector((state: RootReducer) => { return state.appReducer.blnAppDisclaimerAgreed });
    const loading = useSelector((state: RootReducer) => state.ismagCriteriaReducer.loading);
    const ctries = useSelector((state: RootReducer) => state.ismagCriteriaReducer.countries);
    const ismagSearchDone = useSelector((state: RootReducer) => state.ismagReducer.searchDone);
    const history = useHistory();
    const [reset, setReset] = useState(0);
    const[disableButton, setDisableButton] = useState(false);
    const[displayLoading, setDisplayLoading] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect( () => {                
        if (criteriaOrSearchError){
            setDisableButton(false);
            setDisplayLoading(false);
        } 
    })

    useEffect(() => {
        if (! displayLoading) {
            fetchCountries(rootDispatch);
        }
        // this would re-render
        //  setTimeout(() => {
        //      setState({type:"IsmagCriteria/LOADINGFINISHED"})
        //  }, 4000);
        // return is for doing cleanup - does not re-render
        return () => {
            // does not re-render here!!!!!!!
            // setTimeout(() => {
            //     setState({type:"IsmagCriteria/LOADINGFINISHED"})
            // }, 4000);

        }
    }        // This tells React that your effect doesn’t depend on any values from props or state, so it never needs to re-run.
        , [rootDispatch, displayLoading]
    )

    useEffect(() => {
        if (ismagSearchDone) {
            // push new history item == redirect to results page while maintaining the back button function
            history.push("/ismagresults")
        }
        // clean-up immediately as without resetting the searchDone the nex render would be adding another history item
        return (() => { rootDispatch({ type: "Ismag/RESETSEARCH" });                        
                        })
    }, [ismagSearchDone, history, rootDispatch])


    /**
     * reset all the fields
     */
    const onIsmagReset = useCallback(() => {            
        rootDispatch({ type: "Ismag/FETCHERROR", payload: "" });
        setReset(reset + 1);
    }, [reset]);

    // const dispatchDisclaimer = useDispatch()
    const formRef = useRef(null)
    const onSubmitHandle = useCallback(() => {
        //console.log("event here form there " + (typeof formRef))
        //const form: HTMLFormElement = ev.target as HTMLFormElement; 
        if (formRef.current !== null) {
            const elmForm = formRef.current as unknown as HTMLFormElement;
            const data = new FormData(elmForm);
            //alert("Searching:" + stringifyFormData( data));
            setDisplayLoading(true);
            setDisableButton(true);
            fetchIsmagIssuers(rootDispatch, rootDispatchHistory,  data, window.history.state);
        }
        //event.preventDefault()
        //console.log("event here" + stringifyFormData( data))
        //console.log("ismag criteria after Searching")
        return false;
    }, [rootDispatch, rootDispatchHistory])

    return (
        <div>
            <Disclaimer />
            { disclaimerAccepted && ( loading || displayLoading ) && (<> <span>LOADING...</span>   </>)}
            { disclaimerAccepted && criteriaOrSearchError && (
                <div style={{ clear: "both" }}>
                    <ul >
                        <li className="codelist-header bold">{criteriaOrSearchError}</li>
                    </ul>
                </div>
            )}
            { ! displayLoading && !loading && disclaimerAccepted  && (
                <form ref={formRef} onSubmit={(e) => {
                    e.preventDefault(); //onSubmitHandle(e)   
                }}>
                    <p className="codelist-header">Issuer ISMAG Adherence</p>
                    <div className="search-header-info">
                        <p>Please enter your search criteria in the fields below. To search on a range of issuers, the wildcard character * may be used in fields marked with (*).</p>
                        <p><span className="bold">Download facilities are available on the next pages.</span></p>
                    </div>
                    <div className="search-control">
                        <span><button disabled = {disableButton} onClick={onSubmitHandle}>Search</button></span>
                        <span><button disabled = {disableButton} onClick={onIsmagReset}>Reset</button></span>
                    </div>
                    {(
                        <div className="search-table">
                            <InputTextCl 
                                id="ismagIss" 
                                label="(*) Issuer Name :" 
                                name="issuerName"
                                reset={reset} />
                            <SelectCl
                                id="ismagCtry"
                                label="ISO Country Code (ISO) : "
                                name="ctry"
                                options={ctries}
                                reset={reset} />
                            <SelectCl
                                id="ismagType"
                                label="ISMAG Adherence : "
                                name="adherence"
                                options={domainIsmagType}
                                reset={reset} />
                        </div>
                    )}
                </form>
            )}
        </div>

    )
}

export default IsmagCriteria